<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/yovWRM/tc-custom/9781685507336.jpg?1723404399312" alt="This image is the cover for the book Beware of Psychics Box Set"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Beware of Psychics Box Set
      </h1>
      <p class="bookDescription body article font2">
        <p>Having a psychic ability should make life easier, but it isn't always the case.<br/><br/>In this box set, you'll meet three men with amazing abilities that could've made their lives great, but instead of making things easier, they cause trouble. Either they have to hide what they can do, or they can't control it. But maybe there is happiness to be found even for an out-of-luck psychic?<br/><br/>Contains the stories:<br/><br/><strong>How to Hook a Vampire</strong>: A vampire on guard. A psychic on the run. A cabin with one bed. Jameson trusted the wrong person and hides in his uncle's fishing cabin. Harland comes back after having fed only to find his home inhabited, and no one is happier than him that he didn't snack on the sleeping man when it turns out he’s his boss' nephew. But how long before danger finds them in the cabin?<br/><br/><strong>The Bear Claw</strong>: In a world where everyone is either dominant or submissive, Shiro doesn’t have many choices. As a sub, any dom coming to his bakery can give him orders. Pitch wants a mate, but he won’t settle for anything but a true mate. As an alpha shifter, he can have his pick, but his true mate is hiding in the kitchen of a bakery and refuses to see him. How many cups of coffee will it take to lure him out?<br/><br/><strong>Batshit Bassel</strong>: Some people perform miracles, others serve soup. Bassel is a psychic with no control over his powers. He'll never work wonders, but he can serve soup. Thor lost his sister and became the guardian of his nephew, but his life doesn't have room for a cub. Bassel aches for the little boy cloaked in grief and the growling bear he lives with, but will soup be enough to ease their sorrows?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Holly Day
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3413e4bd